import React from 'react'

const Yourneed = () => {
  return (
    <div className='grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1'>
      <div className=''>
      <img className="w-[743.74px] h-[409.53px] rounded-md " src={require("../assets/image 118.png")} alt=""  />
      </div>
      <div className=' mt-20  px-5'>
        <h3 className='text-[32px] font-bold lg:my-10 md:my-10 mt-0'>What do you need?</h3>
        <h3>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor quaerat suscipit neque, dolorem numquam facilis doloremque sequi sit dignissimos perferendis ab aliquid ut deserunt, eos quos at voluptatem ea vitae nobis placeat, accusamus nam voluptatibus exercitationem! Voluptatum repellat distinctio odit architecto sint, fuga recusandae illo nemo tenetur ipsum, dicta quasi rem deserunt in exercitationem corporis dolore, accusantium minus voluptatem nesciunt.</h3>
      </div>
    </div>
  )
}

export default Yourneed
